<template>
  <div class="background">
    <div class="services_top" v-if="mobile==false" >
      <div class="services_side_title" @click="showdata2">Categories
        <img src="../../assets/up.svg" alt="up" v-if="show">
        <img src="../../assets/down.svg" alt="down" v-else>
      </div>
      <div  class="services_side_main" v-if="show">
        <div class="services_side_content" @click="changerouter('/online')">Top 100 Online stores 2024</div>
        <div class="services_side_content" @click="changerouter('/shopify')">Top 100 SHOPIFY stores 2024</div>
        <div class="services_side_content services_side_content2" @click="changerouter('/bigcommerce')">Top 100 BIGCOMMERCE stores 2024</div>
        <div class="services_side_content services_side_content2" @click="changerouter('/woocommerce')">Top 100 WOOCOMMERCE stores 2024</div>
      </div>
    </div>
    <div class="online">
      <div class="services_left" v-if="mobile">
        <div class="services_side">
        <div class="services_side_title">CATEGORIES</div>
        <div class="services_side_content" @click="changerouter('/online')">Top 100 Online stores 2024</div>
        <div class="services_side_content" @click="changerouter('/shopify')">Top 100 SHOPIFY stores 2024</div>
        <div class="services_side_content services_side_content2" @click="changerouter('/bigcommerce')">Top 100 BIGCOMMERCE stores 2024</div>
        <div class="services_side_content services_side_content2" @click="changerouter('/woocommerce')">Top 100 WOOCOMMERCE stores 2024</div>
        </div>
      </div>
      <div>
        <h1 class="headertable" >{{title}}</h1>
        <div class="overflow">
        <div class="control_table">
        <table class="table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Store</th>
              <th>Global rank</th>
              <th>Country</th>
              <th>Traffic/month (estimated)</th>
            </tr>
          </thead>
          <tbody id="idData">
          <tr v-for="(item, index) in arr" :key="index" @click="linkurl(item)" :title=item.title>
          <td >{{item.id}}</td>
          <td >
              <span class="_1LCG" v-if="item.image==''" >{{item.name2}}</span>
              <img :src=item.image  alt="" class="_2p8C" loading="lazy"  v-else />
              {{item.name}}
          </td>
          <td>{{item.global | global}}</td>
          <td>{{item.country | country}}</td>
          <td>{{item.Traffic | Traffic}}</td>
          </tr>
        </tbody>
        </table>
        </div>
        <div class="changepage">
          <Paging
            :page-index="currentPage"
            :total="count"
            :page-size="pageSize"
            @change="pageChange"
          ></Paging>
        </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import Footer from "../common/footer.vue";
import Paging from "../common/paging.vue";

export default {
  name: "toplist",
  components: {
    Header,
    Footer,
    Paging,
  },
  props:['title','url'],
  data() {
    return {
      tabledata:[],
      currentPage: 1,
      pageSize: 20,
      count: 100,
      arr: [],
      mobile:true,
      show:false,
      index:0,
      screenwidth:document.body.offsetWidth
    };
  },
  filters: {
    country(value){
      if(value=="United States of America"){
        return "United States"
      }else{
        return value
      }
    },
    global(value){
      let number=Number(value)
      if(number>=100000){
        number=number.toString().slice(0, 3) + "," + number.toString().slice(3);
      }else if(number>=10000&&number<100000){
        number=number.toString().slice(0, 2) + "," + number.toString().slice(2);
      }else if(number<10000&&number>=1000){
        number=number.toString().slice(0, 1) + "," + number.toString().slice(1);
      }
      return number
    },
    Traffic(value){
      value=value.replace(".00","")
      return value
    }
  },
  created() {
    let timenow=new Date().getTime()
    this.$axios.get(`https://platform.antdiy.vip/site/antdiy/top-stores-list/${this.url}?time=`+timenow).then(res=>{
      let data=res.data.result.pageContext.story.content.storeList
      if(data.length<100){
        this.count=data.length
      }
      for(let i=0;i<this.count;i++){
        let obj={
          id: i+1,
          url: data[i].url,
          title:"Check the "+(data[i].company_name==""?data[i].domain:data[i].company_name)+" store",
          image:data[i].logo,
          name:data[i].company_name==""?data[i].domain:data[i].company_name,
          name2:data[i].company_name==""?data[i].domain:data[i].company_name,
          global: data[i].alexa_url_info.rank,
          country: data[i].country_name,
          Traffic: data[i].monthly_traffic,
        }
        this.tabledata.push(obj)
     }
    }).then(res=>{
       this.pageChange(1)
    })
    document.title=this.title
  },
  mounted(){
    // 全局绑定的记得销毁,不然其他页面也会触发
    if (document.body.offsetWidth < 767) {
      window.addEventListener("click", this.listclick);
    }
    const that=this
    window.onresize=()=>{
      return (()=>{
        window.screenWidth=document.body.offsetWidth
        that.screenwidth=window.screenWidth
      })()
    }
  },
  deactivated () {
    window.removeEventListener("click", this.listclick)
  },
  methods: {
    pageChange(page){
       this.currentPage = page;
       this.arr=[];
       let i;
       let lastdata=this.count%this.pageSize
       let pagedata=parseInt(this.count/this.pageSize)
      //  console.log((pagedata>=page?(page*this.pageSize):lastdata))
       for(i=(page-1)*this.pageSize;i<(pagedata>=page?(page*this.pageSize):((page-1)*this.pageSize+lastdata));i++){
        if(this.tabledata[i].image==""){
          this.tabledata[i].name2=this.tabledata[i].name2.slice(0,1)
        }
        this.arr.push(this.tabledata[i])
       }
    },
    linkurl(item) {
      window.open(item.url);
    },
    listclick(){
      document.querySelector(".online").style.paddingTop="2.2rem"
      this.show=false
      if(this.index==1){
        this.index=this.index-1
      }
    },
    showdata2(){
      window.event? window.event.cancelBubble = true : e.stopPropagation();
      if(this.index==0){
        this.show=true
        this.index=this.index+1
        document.querySelector(".online").style.paddingTop="5.6rem"
      }else if(this.index==1){
        this.show=false
        this.index=this.index-1
        document.querySelector(".online").style.paddingTop="2.2rem"
      }
    },
    changerouter(index){
      if (document.body.offsetWidth < 767) {
        document.querySelector(".online").style.paddingTop="2.2rem"
      }
      this.show=false
      if(index=='/online'&&index!=location.pathname){
        this.$router.push({
          path:'online'
        })
      }else if(index=='/shopify'&&index!=location.pathname){
        this.$router.push({
          path:'shopify'
        })
      }else if(index=="/bigcommerce"&&index!=location.pathname){
        this.$router.push({
          path:'bigcommerce'
        })
      }else if(index=="/woocommerce"&&index!=location.pathname){
        this.$router.push({
          path:'woocommerce'
        })
      }
    }
  },
  watch:{
    screenwidth:{
      immediate:true,
      handler:function(value){
        if(value>750){
          this.mobile = true
        } else {
          this.mobile = false
        }
      }
    }
  },
};
</script>

<style scoped>
.background{
  background: #F6F7FA;
}
.headertable {
  text-align: left;
  margin-top: 60px;
  font-size: 32px;
  font-weight: bold;
  color: #222536;
  margin-bottom: 31px;
}
.online {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.services_side{
  margin-top:65px
}
.services_side_title{
  font-family: Helvetica-Bold;
  font-size: 14px;
  color: #8D919B;
  letter-spacing: 0;
  font-weight: 700;
  margin: 0 0 34px 16px;
}
.services_side_line{
  width: 248px;
  height: 1px;
  border: 1px solid rgba(0,0,0,.08);
  margin: 31.5px 0 19.5px 0;
}
.services_side_box{
  width: 249px;
  height: 95px;
  background: #FFFFFF;
  border-radius: 6px;
}
.services_side_box_div{
  padding: 16px;
}
.services_side_box_div1{
  opacity: 0.85;
  font-family: Helvetica;
  font-size: 14px;
  color: #32404D;
  letter-spacing: 0;
  line-height: 19px;
  font-weight: 400;
  margin-bottom: 4px;
}
.services_side_box_div2{
  opacity: 0.85;
  font-family: Helvetica;
  font-size: 14px;
  color: #32404D;
  letter-spacing: 0;
  line-height: 19px;
  font-weight: 400;
}
.services_side_content{
  font-family: Helvetica;
  font-size: 16px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 400;
  width:248px;
  height: 44px;
  opacity: 0.9;
  padding: 10px 0px 10px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.services_side_content2{
  height: 58px;
}
.services_side_content:hover{
  background:rgb(141,145,155,0.1);
  border-radius: 6px;
}
.overflow{
  width: 912px;
  background: #FFFFFF;
  box-shadow: 0px 2px 24px 0px rgba(139,145,160,0.1);
  border-radius: 8px;
  padding: 22px 20px 45px 24px;
  margin-bottom: 52px;
}
.table {
  width: 868px;
  margin: auto;
  border: 1px solid #c4cdd5;
  margin-bottom: 41px;
  table-layout: inherit;
}

thead {
  border-bottom: 1px solid #c4cdd5;
  /* outline: 1px solid rgba(196,205,213,.5); */
}
tr {
  border-bottom: 1px solid #c4cdd5;
}
.table td:first-of-type {
  font-weight: 700;
  width: 10%;
}
.table td:nth-of-type(2) {
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 230px;
  width: 25%;
}
.table td:nth-of-type(3) {
  width: 15%;
}
.table td:nth-of-type(4) {
  width: 20%;
}
.table td:nth-of-type(5) {
  width: 25%;
}
td >>> img {
  height: 32px !important;
  width: 32px !important;
  border-radius: 50% !important;
  margin-right: 8px !important;
}
td >>> ._1LCG {
  background: #e9ecef !important;
  height: 32px !important;
  width: 32px !important;
  border-radius: 50% !important;
  margin-right: 8px !important;
  align-items: center !important;
  display: inline-flex !important;
  font-size: 13px !important;
  justify-content: center;
}
td {
  vertical-align: middle;
  text-align: left;
  padding: 11px 12.5px;
}
th {
  padding: 13px 12.5px;
  text-align: left;
}
.changepage {
  display: flex;
  justify-content: right;
}
caption {
  font-size: 32px;
  font-weight: bold;
  color: #222536;
  margin-bottom: 20px;
}
tbody :hover {
  background-color: #f6f7f8;
  cursor: pointer;
}

@media (max-width: 767px) {
  .services_top{
    width: 100%;
    position: fixed;
    z-index:99;
    top:1rem;
  }
  .services_side_title{
    width: 100%;
    font-family: Helvetica;
    font-size: .36rem;
    color: rgba(34,37,54,.85);
    margin:0;
    height: .88rem;
    padding: .2rem .48rem .2rem .48rem;
    cursor: pointer;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: initial;
    border-top:.02rem solid rgba(0,0,0,.06);
  }
  .services_side_main{
    width: 100%;
  }
  .services_side_box{
    width: 100%;
    height: 1.52rem;
    background: #FFFFFF;
    border-radius: .12rem;
    margin-bottom: .56rem;
  }
  .services_side_box_div{
    padding: .32rem .28rem .32rem .32rem;
  }
  .services_side_box_div1{
    opacity: 0.85;
    font-family: Helvetica;
    font-size: .28rem;
    color: #32404D;
    letter-spacing: 0;
    line-height: .38rem;
    font-weight: 400;
    margin-bottom: .08rem;
  }
  .services_side_box_div2{
    opacity: 0.85;
    font-family: Helvetica;
    font-size: .28rem;
    color: #32404D;
    letter-spacing: 0;
    line-height: .38rem;
    font-weight: 400;
    font-weight: 400;
  }
  .services_side_content{
    height: .88rem;
    width: 100%;
    background: #FFFFFF;
    font-family: Helvetica;
    font-size: .32rem;
    color: #222536;
    letter-spacing: 0;
    font-weight: 400;
    opacity: 1;
    padding: .22rem 0 .22rem .48rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-bottom: .01rem solid rgba(0,0,0,.06) ;
  }
  .services_side_content:hover{
    color: #FB5421;
    background-color: #FFFFFF;
    border-radius: 0;
  }
  .online {
    width: 100%;
    padding: 2.2rem 0.4rem 1.2rem .4rem;
    display: block;
  }
  .headertable {
    margin: 0;
    font-size: 0.36rem;
  }
  .table {
    width: 100%;
    margin: 0;
  }
  .changepage {
    justify-content: center;
  }
  .table th:first-of-type {
    padding-right: .6rem;
  }
  .table td:first-of-type {
    font-weight: 700;
    width: 10%;
    padding-right: .6rem;

  }
  .table td:nth-of-type(2) {
    font-weight: 700;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 25%;
  }
  .table td:nth-of-type(3) {
    width: 15%;
  }
  .table td:nth-of-type(4) {
    width: 20%;
  }
  .table td:nth-of-type(5) {
    width: 25%;
  }
  td >>> img {
    border-radius: 50% !important;
    margin-right: .1rem !important;
  }
  td >>> ._1LCG {
    background: #e9ecef !important;
    border-radius: 50% !important;
    margin-right: .1rem !important;
    align-items: center !important;
    display: inline-flex !important;
    font-size: .13rem !important;
    justify-content: center;
  }
  td {
    vertical-align: middle;
    text-align: left;
    padding: .4rem .4rem;
  }
  th {
    padding: .13rem .4rem;
    text-align: left;
  }
  .changepage >>>.page_num_show{
    padding-top: 0;
  }
  .overflow{
    width: 100%;
    display:block ;
    box-shadow:none;
    border-radius: 0;
    padding:0;
    margin:.4rem 0 .56rem 0
  }
  .control_table{
    width: 100%;
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/toplist.vue